module.exports = "https://static-production.npmjs.com/97ce287600f35d9d5f2ed500630bb0ad.png";